const ALL_DOCUMENTS_TYPES = {
  LISTING: 'LISTING',
  LEASE: 'LEASE',
  SIGNATURE_REQUEST: 'SIGNATURE_REQUEST',
};

export default ALL_DOCUMENTS_TYPES;
